/*
 * <lp-review-wall> — filter chips (stars / topics), live counter and "Load more".
 * Cards are rendered by Liquid (one block per review); JS only shows/hides them.
 */
(function () {
  'use strict';
  class LPReviewWall extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.lp-allrev__card'));
      this.filters = Array.from(this.querySelectorAll('.lp-allrev__filter'));
      this.loadWrap = this.querySelector('[data-loadmore-wrap]');
      this.loadBtn = this.querySelector('[data-loadmore]');
      this.visibleEl = this.querySelector('[data-visible]');
      this.totalEl = this.querySelector('[data-total]');
      this.emptyEl = this.querySelector('[data-empty]');
      this.mq = window.matchMedia('(max-width: 768px)');
      this.filter = 'all';
      this.reset();

      this.filters.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.filter = btn.dataset.filter;
          this.filters.forEach((b) => b.classList.toggle('is-active', b === btn));
          this.reset();
        });
      });
      if (this.loadBtn) {
        this.loadBtn.addEventListener('click', () => {
          this.visible += this.step();
          this.render();
        });
      }
      this.onMq = () => this.reset();
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
    }
    disconnectedCallback() {
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
    }
    initial() {
      return parseInt(this.mq.matches ? this.dataset.initialMobile : this.dataset.initial, 10) || 16;
    }
    step() {
      return parseInt(this.mq.matches ? this.dataset.stepMobile : this.dataset.step, 10) || 12;
    }
    reset() {
      this.visible = this.initial();
      this.render();
    }
    matches(card) {
      if (this.filter === 'all') return true;
      const [type, value] = this.filter.split(':');
      if (type === 'stars') return card.dataset.stars === value;
      if (type === 'topic') return (card.dataset.topics || '').split(' ').indexOf(value) > -1;
      return true;
    }
    render() {
      const list = this.cards.filter((c) => this.matches(c));
      const hideMedia = this.dataset.imagesOnlyAll === 'true' && this.filter !== 'all';
      this.cards.forEach((c) => { c.hidden = true; c.classList.toggle('hide-media', hideMedia); });
      list.slice(0, this.visible).forEach((c) => { c.hidden = false; });
      const shown = Math.min(this.visible, list.length);
      if (this.visibleEl) this.visibleEl.textContent = shown;
      if (this.totalEl) this.totalEl.textContent = list.length;
      if (this.emptyEl) this.emptyEl.hidden = list.length > 0;
      if (this.loadWrap) this.loadWrap.hidden = shown >= list.length;
    }
  }
  if (!customElements.get('lp-review-wall')) customElements.define('lp-review-wall', LPReviewWall);

  /* Theme editor: reveal a selected review even if it's beyond "Load more" */
  document.addEventListener('shopify:block:select', (e) => {
    const card = e.target.closest && e.target.closest('.lp-allrev__card');
    if (card && card.hidden) {
      const wall = card.closest('lp-review-wall');
      if (wall) { wall.visible = wall.cards.length; wall.render(); }
    }
  });
})();